import { Copy } from '@grubhubprod/gh-cookbook-react/dist';
import React, { useEffect } from 'react';

import { Flex, Stack, SvgX } from '@grubhubprod/gh-cookbook-react';
import { timeToWaitUntilErrorCloses } from 'src/components/selfService/features/OrderHistory/OrderHistory.utils';

interface IGenerateErrorStateProps {
  onErrorClose: () => void;
}

export function GenerateErrorState({
  onErrorClose,
}: IGenerateErrorStateProps): JSX.Element {
  useEffect(() => {
    const timer = setTimeout(() => {
      onErrorClose();
    }, timeToWaitUntilErrorCloses);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex alignItems="center">
      <Stack color="danger" x="xx-sm">
        Download failed. Try again.
      </Stack>
      <Copy variant="body" color="secondaryText">
        <SvgX
          size="20px"
          cursor="pointer"
          color="secondaryText"
          onClick={onErrorClose}
        />
      </Copy>
    </Flex>
  );
}
